import { useEffect } from 'react';
import * as Sentry from '@sentry/react';
import { User } from './assets/App/Context/UserContext';

type UseSentryProps = { user?: User | null | undefined };

export const sentryInit = () => {
  Sentry.init({
    dsn: process.env.SENTRY_DSN,
    integrations: [Sentry.browserTracingIntegration({})],
    tracesSampleRate: 0.1, // 10% Requests in Production
    tracePropagationTargets: ['localhost', /^https:\/\/naskorsports\.com/],
  });
};

export function useSentry({ user }: UseSentryProps) {
  useEffect(() => {
    if (user) {
      Sentry.setUser({ id: user.id });
    }
  }, [user]);
}
